"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), !function(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: !0,
        get: all[name]
    });
}(exports, {
    IMPERSONATE_SESSION_TTL_MS: function() {
        return IMPERSONATE_SESSION_TTL_MS;
    },
    REFRESH_TOKEN_TTL_MS: function() {
        return REFRESH_TOKEN_TTL_MS;
    },
    SESSION_AUTH_TOKEN_TTL_MS: function() {
        return SESSION_AUTH_TOKEN_TTL_MS;
    },
    STRONG_AUTH_TOKEN_TTL_MS: function() {
        return STRONG_AUTH_TOKEN_TTL_MS;
    }
});
const REFRESH_TOKEN_TTL_MS = 86400000, STRONG_AUTH_TOKEN_TTL_MS = 300000, SESSION_AUTH_TOKEN_TTL_MS = 3600000, IMPERSONATE_SESSION_TTL_MS = 600000;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9odHRwL2F1dGgvQXV0aFR0bC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIvLyBUaGlzIGhhcyBiZWVuIHNldCB0byBleHBpcmUgYWZ0ZXIgMjQgaG91cnMgZm9yIHNlY3VyaXR5XG5leHBvcnQgY29uc3QgUkVGUkVTSF9UT0tFTl9UVExfTVMgPSAyNCAqIDYwICogNjAgKiAxMDAwIC8vIDEgZGF5XG5leHBvcnQgY29uc3QgU1RST05HX0FVVEhfVE9LRU5fVFRMX01TID0gNSAqIDYwICogMTAwMCAvLyA1IG1pblxuLy8gVXNlZCB3aGVuIGNyZWF0aW5nIHJlZnJlc2ggdG9rZW5zIHRoYXQgZG8gbm90IG5lZWQgdG8gbGl2ZSBmb3IgYSBsb25nIHRpbWUsIG5vcm1hbCBhdXRoZW50aWNhdGlvbiBzZXNzaW9uXG5leHBvcnQgY29uc3QgU0VTU0lPTl9BVVRIX1RPS0VOX1RUTF9NUyA9IDYwICogNjAgKiAxMDAwIC8vIDEgaG91clxuLy8gVXNlZCBmb3Igc3BvbnNvcnMgaW1wZXJzb25hdGluZyBzcG9uc2Vlc1xuZXhwb3J0IGNvbnN0IElNUEVSU09OQVRFX1NFU1NJT05fVFRMX01TID0gMTAgKiA2MCAqIDEwMDAgLy8gMTAgbWluXG4iXSwibmFtZXMiOlsiSU1QRVJTT05BVEVfU0VTU0lPTl9UVExfTVMiLCJSRUZSRVNIX1RPS0VOX1RUTF9NUyIsIlNFU1NJT05fQVVUSF9UT0tFTl9UVExfTVMiLCJTVFJPTkdfQVVUSF9UT0tFTl9UVExfTVMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztJQU1hQSwwQkFBMEI7ZUFBMUJBOztJQUxBQyxvQkFBb0I7ZUFBcEJBOztJQUdBQyx5QkFBeUI7ZUFBekJBOztJQUZBQyx3QkFBd0I7ZUFBeEJBOzs7QUFETixNQUFNRix1QkFBdUIsVUFDdkJFLDJCQUEyQixRQUUzQkQsNEJBQTRCLFNBRTVCRiw2QkFBNkIifQ==